


$(document).ready(function() {



  // Initially set the background and border for checked radio button
  $('input[type=radio]:checked').each(function() {
    $(this).closest('.custom-radio-button-varaint').css({
      'background': 'rgba(60, 9, 27, 0.05)',
      'border': '2px solid #3c091b'
    });
  });

  // When a radio button is clicked (changed)
  $('input[type=radio][name="Size"]').on('change', function() {
    // Reset background and border for all radio button containers
    $('.custom-radio-button-varaint').css({
      'background': '',
      'border': ''
    });

    // Set background to red and border to #3c091b for the selected radio button's parent container
    $(this).closest('.custom-radio-button-varaint').css({
      'background': 'rgba(60, 9, 27, 0.05)',
      'border': '2px solid #3c091b'
    });
  });


  
 $('.custom-testimoanil').slick({
  arrows: true,
  infinite: true,
  dots: false,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  slidesToShow: 3, // Adjusted this to 4
  responsive: [
    {
      breakpoint: 760,
      settings: {
        arrows: true,
        infinite: true,
        slidesToShow: 1
      }
    }
  ]
});









});

